import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("kx_wishlist")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("kx_wishlist", JSON.stringify(items));
  }, [items]);

  const isSaved = (id) => items.some((i) => i.product_id === id);

  const toggle = (product) => {
    setItems((prev) => {
      if (prev.some((i) => i.product_id === product.id)) {
        toast("Removed from wishlist");
        return prev.filter((i) => i.product_id !== product.id);
      }
      toast.success("Saved to wishlist");
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          slug: product.slug,
          image: product.image,
          price: product.price,
          category: product.category,
          short_desc: product.short_desc,
          compare_price: product.compare_price,
          rating: product.rating,
          reviews_count: product.reviews_count,
          stock: product.stock,
        },
      ];
    });
  };

  const remove = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));

  const count = items.length;

  return (
    <WishlistContext.Provider value={{ items, isSaved, toggle, remove, count }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
